import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=5e4e0e04&scoped=true"
import script from "./indexCopy.vue?vue&type=script&lang=js"
export * from "./indexCopy.vue?vue&type=script&lang=js"
import style0 from "./indexCopy.vue?vue&type=style&index=0&id=5e4e0e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e0e04",
  null
  
)

export default component.exports